import React, { useState } from 'react';
import { FadeIn, Section } from './Section';
import { PlusIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const pains = [{
  title: 'Sabés que podés cobrar más... pero no sabés cómo',
  desc: 'No tenés claro qué ofrecer, a quién, ni cuánto cobrar sin sentirte rara.'
}, {
  title: 'Cada vez que alguien te pide precio, dudás',
  desc: 'Calculás, bajás el número, y terminás aceptando menos de lo que vale tu trabajo.'
}, {
  title: 'Sentís que necesitás más preparación antes de empezar',
  desc: 'Otro curso, otro certificado, otra cosa. Y mientras tanto, el tiempo pasa.'
}, {
  title: 'Dependés del sueldo de otro o de lo que te ofrezcan',
  desc: 'No tenés ingresos propios, constantes y predecibles que dependan solo de vos.'
}, {
  title: 'Sabés que algo está mal con tu relación con el dinero, pero no sabés qué',
  desc: 'Creencias heredadas que frenan tu prosperidad sin que te des cuenta.'
}, {
  title: 'Trabajás mucho y el dinero nunca alcanza',
  desc: 'Esfuerzo máximo, resultado mínimo. Y no entendés por qué.'
}, {
  title: 'Ves a otras mujeres monetizar y pensás "¿por qué ella sí y yo no?"',
  desc: 'La diferencia no es el talento. Es el método y la mentalidad.'
}, {
  title: 'Fin de mes y seguís en el mismo lugar',
  desc: 'Sin un sistema claro, los ingresos no crecen solos.'
}];
function PainPointItem({
  pain,
  i
}: {
  pain: (typeof pains)[0];
  i: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={i * 0.05} className="flex flex-col md:flex-row gap-4 items-start border-b border-plum/10 md:border-none pb-4 md:pb-0" data-id="element-176">
      {/* Mobile Accordion Header */}
      <button className="md:hidden flex justify-between w-full text-left items-center gap-4" onClick={() => setIsOpen(!isOpen)} data-id="element-177">
        <h3 className="font-bold text-sm text-plum leading-snug pr-2" data-id="element-178">
          {pain.title}
        </h3>
        <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-plum/5 text-plum" data-id="element-179">
          <PlusIcon size={14} className={`transform transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-180" />
        </div>
      </button>

      {/* Mobile Accordion Content */}
      <AnimatePresence data-id="element-181">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="md:hidden overflow-hidden w-full" data-id="element-182">
            <p className="text-plum/70 text-sm pt-2 pb-2" data-id="element-183">{pain.desc}</p>
          </motion.div>}
      </AnimatePresence>

      {/* Desktop Static Layout */}
      <div className="hidden md:flex gap-4 items-start" data-id="element-184">
        <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-gold mt-2.5" data-id="element-185" />
        <div data-id="element-186">
          <h3 className="font-bold text-lg text-plum mb-2 leading-snug" data-id="element-187">
            {pain.title}
          </h3>
          <p className="text-plum/70 leading-relaxed" data-id="element-188">{pain.desc}</p>
        </div>
      </div>
    </FadeIn>;
}
export function PainPoints() {
  return <Section bg="cream" data-id="element-189">
      <FadeIn className="text-center mb-10 md:mb-24" data-id="element-190">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-plum/60 mb-4" data-id="element-191">
          ¿Te pasa esto?
        </h2>
        <p className="font-serif text-3xl md:text-5xl text-plum max-w-3xl mx-auto leading-tight" data-id="element-192">
          Si sos mujer y tenés una habilidad, esto te suena familiar:
        </p>
      </FadeIn>

      <div className="flex flex-col md:grid md:grid-cols-2 gap-x-12 gap-y-4 md:gap-y-10 max-w-5xl mx-auto" data-id="element-193">
        {pains.map((pain, i) => <PainPointItem key={i} pain={pain} i={i} data-id="element-194" />)}
      </div>

      <FadeIn delay={0.4} className="mt-12 md:mt-20 text-center" data-id="element-195">
        <p className="font-serif md:text-3xl italic text-plum text-[24px]" data-id="element-196">
          ¿Cuántos meses más vas a tener la habilidad y seguir sin cobrar por
          ella?
        </p>
      </FadeIn>
    </Section>;
}